import React from "react";
import {ConfigProvider, DatePicker, Tooltip} from "antd";
import moment from "moment";
import "moment/locale/fi";
import locale from "antd/es/date-picker/locale/fi_FI";
import CoursesHeader from "./CoursesHeader";
import {FixedSizeList as List} from 'react-window';
import {CourseRow} from "./CourseRow";
import {useCoursesList} from "./useCoursesList";
import fi from 'antd/locale/fi_FI';

export default () => {
    const {setDateValue, days, filteredGolfCourses} = useCoursesList();
    // console.log('[[MiniList]]', {filteredGolfCourses})
    return (
        <div className={'wrapper'} style={{
            overflow: "hidden",
        }}>
            <CoursesHeader days={days} picker={
                <Tooltip title='Valitse päivä'>
                    <div style={{
                        display: "flex",
                        width: "100%",
                        justifyContent: "left",
                    }}>
                        <ConfigProvider locale={fi} >
                        <DatePicker
                            onChange={(date, dateString) => setDateValue(dateString)}
                            allowClear={false}
                            disabledDate={current => current.isBefore(moment().subtract(1, "day"))} //   picker='week'
                            locale={locale}
                        />
                        </ConfigProvider>
                    </div>

                </Tooltip>
            }/>
            <List
                height={window.innerHeight - 215}
                itemCount={filteredGolfCourses.length}
                itemSize={75}
                width={window.innerWidth - 10}
            >
                {CourseRow}
            </List>
        </div>
    );
};
